import { z } from "zod";

export const frameCostPerImageBackgroundRemoval = 5;

export const tool = "image-background-remover";

export const schema = z.object({
  image: z.instanceof(File, { message: "Please upload an image" }),
});
